<a (click)="logout()" class="nav-link" href="#"><i class="fas fa-sign-out-alt"> </i> Log Out</a>


